<template>
    <div>
        <el-dialog v-dialog-drag :visible.sync="dialogVisible" class="eldialog eldialogLine no_print" :modal="false" title="关联应收费用" custom-class="full_dialog">
            <div class="relativeBox clearfix" v-for="(item) in feeList" :key="item.id">
                <!--<img :src="item.isChecked?'/cloud/checked.png':'/cloud/check.png'" class="relativeImg"-->
                     <!--@click="isEdit?feeChecked(item.id):''"/>-->
                <!--<div class="relativeName">{{item.name}}:</div>-->
                <el-checkbox class="relativeCheckbox" :disabled="!isEdit" v-model="item.isChecked"
                             @change="feeChecked(item.id)">
                    {{item.name}}:
                </el-checkbox>
                <el-input class="relativeInput" :disabled="!isEdit||!item.isChecked" v-model="item.value"></el-input>
                <el-checkbox v-if="hasRec" :disabled="!isEdit||!item.isChecked"
                             class="recCheckbox" v-model="item.rec">REC</el-checkbox>
            </div>
            <div class="relativeBox clearfix">
                <el-checkbox :disabled="!isEdit" v-model="remarkFlag">
                    费用明细显示在备注信息里面
                </el-checkbox>
            </div>
            <div class="dialogBtnList clearfix" v-if="isEdit">
                <el-button class="dialogBtn funcPublicBtn" @click="dialogVisible=!dialogVisible">取消</el-button>
                <el-button  class="publicBtn dialogBtn" :disabled="confirmLoading" @click="confirm">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<style lang="scss" scoped>
    .relativeBox{margin-bottom:10px;}
    .relativeImg{width:15px;height:15px;display: block;float: left;line-height: 25px;margin-top:5px;margin-right:10px;cursor: pointer;}
    .relativeName{font-size: 13px;float: left;line-height: 25px;margin-right:5px;}
    .relativeInput{width:100px;}
</style>
<script>
export default {
    props:['dialogVisibleRelation','data','relatedremark','isEdit','purl','post','id','hasRec'],
    data(){
        return{
            dialogVisible:false,
            feeList:[],
            feeData:this.data,
            remarkFlag:false,
            postUrl:"",
            isPost:false,
            postId:"",

            confirmLoading:false,
        }
    },
    created(){
        this.getFeeListConfig();
    },
    methods:{
        confirm(){
            this.confirmLoading = true;
            let rels = [];
            let remark = "";
            this.feeList.forEach(item => {
                if (item.isChecked) {
                    rels.push({
                        fee_id: item.id,
                        amount: item.value,
                        rec: item.rec
                    });
                    remark += item.name + ":" + item.value + " ";
                }
            });
            this.confirmLoading = false;
            if(remark == ''){
                return
            }
            remark = "关联应收:(" +remark+ ")";
            let object = {
                relate_list: rels,
                total: this.$bc_add(...rels.map(a => a.amount)),
                tax_rec_amount: this.$bc_add(...rels.filter(a => a.rec).map(a => a.amount)),
            };
            if(this.remarkFlag){
                object.related_remark = remark;
            }
            if(this.isPost){
                object.id = this.postId;
                this.$confirmPost('是否确定保存?',this.postUrl,object,()=>{
                    this.tip("修改成功","success")
                    this.$emit("confirm");
                    this.dialogVisible = false;
                });
            }else{
                this.$emit("confirm", object);
                this.dialogVisible = false;
            }
        },
        feeChecked(id){
            let item = this.feeList.find(a => a.id === id);
            if (item) {
                if(!item.isChecked){
                    item.value = "";
                    item.rec = false;
                }
            }
        },
        getFeeListConfig(){
            this.postFunc("/erp/fee.type.order.related",{},res=>{
                let resD = res.data.data;
                resD.forEach(item => {
                    item.isChecked = false;
                    item.value = "";
                    item.rec = false;
                });
                this.feeList = this.$cloneJson(resD);
            },error=>{
                this.tip(error.data.message,"warning")
            })
        },
    },
    watch:{
        id:function(val){
            this.postId = val;
        },
        purl:function(val){
            this.postUrl = val;
        },
        post:function(val){
            this.isPost = val;
        },
        relatedremark:function(val){
            if(val){
                this.remarkFlag = true;
            }else{
                this.remarkFlag = false;
            }
        },
        data: {
            immediate:true,
            deep:true,
            handler:function (val) {
                this.feeData = val;
            }
        },
        feeData: {
            immediate: true,
            deep: true,
            handler: function (val) {
                if (val) {
                    this.feeData.forEach(item => {
                        this.feeList.forEach(list => {
                            if (item.fee_id === list.id) {
                                list.value = item.amount;
                                list.isChecked = true;
                                list.rec = !!item.rec;
                            }
                        })
                    })
                }
            }
        },
        dialogVisibleRelation:function(val){
            this.dialogVisible = val;
        },
        dialogVisible:function(val){
            if(!val){
                //关闭时清除已选的属性
                this.feeList.forEach(item => {
                    item.value = "";
                    item.isChecked = false;
                    item.rec = false;
                });
                this.feeData = [];
                this.$emit("closeDialog");
            }
        },
        feeList:{
            immediate: true,
            deep:true,
            handler:function () {
                this.feeList.map(a => {
                    a.value = this.$digitInput(a.value, 2, false);
                });
            }
        }
        
    }
}
</script>
<style lang="scss" scoped>
    .relativeCheckbox{
        margin-top: 1px;
        margin-right: 10px;
    }
    .recCheckbox{
        margin-left: 10px;
        margin-top: 1px;
    }

</style>